import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    list: 'flex w-fit items-center justify-center rounded-[51px] border-x-1 border-y-2 border-white bg-white/15 p-1 shadow-lg backdrop-blur-xl transition-transform duration-500 ease-out max-lg:mx-auto max-md:mx-2',
    item: 'flex-center flex h-[43px] cursor-pointer text-base leading-[1] whitespace-nowrap text-[#003A70]',
    button:
      'h-full w-full cursor-pointer rounded-[100px] px-3 text-base leading-[1] transition-all duration-200'
  },
  variants: {
    isActive: {
      true: {
        button: 'bg-white font-medium'
      }
    }
  }
});
